export default __webpack_public_path__ + "static/clipboard-activity-dark-23504093f1577d3a88006cc54bf8932a.png";